import React, { useState } from "react";
import {
    HeaderContainer,
    HeaderTitle,
    Logo,
    Titles,
    ProfileContainer,
    HeaderWrap,
    LogoutWrap,
    TitleWrap,
} from "./Header.styled";
import { HeaderTitles } from "./HeaderTitles";
import { Container } from "static/coreStyles/global.styled";
import { Avatar, Popover } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "actions/login";
import { getInitials } from "utility/helperFunctions";

const popoverStyles = {
    overlay: {
        padding: 0,
        margin: 0

    },
    inner: {
        padding: 0,
        margin: 0,

    },
    title: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '4px 8px',
        fontSize: '14px'
    },
    content: {
    },
    logoutButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#6528d8',
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: '500',
        width: '100%',
        textAlign: 'center',
    }
};

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [visible, setVisible] = useState(false);

    const exclusionPaths = ["/login"];

    // Redux state
    const currentUser = useSelector(state => state.Login?.currentUser);
    const users = useSelector(state => state.User?.pagination?.totalCount);
    const rides = useSelector(state => state.Ride?.pagination?.totalCount);
    const groups = useSelector(state => state.Group?.pagination?.totalCount);

    const isActive = (path) => {
        return location.pathname.includes(path);
    };

    const redirect = (path) => {
        if (location.pathname !== path) {
            navigate(path);
        }
    };

    const handleLogout = () => {
        setVisible(false);
        dispatch(userLogout(navigate));
    };

    const handleVisibleChange = (newVisible) => {
        setVisible(newVisible);
    };

    if (!currentUser) return null;

    return (
        <>
            {exclusionPaths.indexOf(location.pathname) < 0 && (
                <HeaderWrap>
                    <Container>
                        <HeaderContainer>
                            <Logo src={require("static/images/logo.svg")} alt="logo" />
                            <Titles>
                                {HeaderTitles.map((title, index) => {
                                    return (
                                        <HeaderTitle
                                            key={index}
                                            active={isActive(title.url)}
                                        >
                                            <div
                                                onClick={() => {
                                                    redirect(title.url);
                                                }}
                                                className="nav-link"
                                            >
                                                <i>
                                                    {isActive(title.url) ? (
                                                        <img src={title.activeIcon} alt="" />
                                                    ) : (
                                                        <img src={title.inactiveIcon} alt="" />
                                                    )}
                                                </i>
                                                <span>{title.title}</span>
                                                {(title.title === 'Users' && users) ||
                                                (title.title === 'Rides' && rides) ||
                                                (title.title === 'Groups' && groups) ? (
                                                    <small>
                                                        {title.title === 'Users' ? users :
                                                         title.title === 'Rides' ? rides :
                                                         title.title === 'Groups' ? groups : null}
                                                    </small>
                                                ) : null}
                                            </div>
                                        </HeaderTitle>
                                    );
                                })}
                            </Titles>

                            <ProfileContainer>
                                <Popover
                                    overlayClassName="profile-popover"
                                    overlayStyle={popoverStyles.overlay}
                                    overlayInnerStyle={popoverStyles.inner}
                                    content={
                                        <div style={popoverStyles.content}>
                                            <LogoutWrap
                                                onClick={handleLogout}
                                                style={popoverStyles.logoutButton}
                                            >
                                                Logout
                                            </LogoutWrap>
                                        </div>
                                    }
                                    title={
                                        <div style={popoverStyles.title}>
                                            <TitleWrap>
                                                <h3 style={{ margin: 0 }}>
                                                    {currentUser && currentUser.email
                                                        ? currentUser.email
                                                        : ""}
                                                </h3>
                                                <h4 style={{ margin: 0, textAlign: 'center' }}>
                                                    {(currentUser.firstName || "") +
                                                        " " +
                                                        (currentUser.lastName || "")}
                                                </h4>
                                            </TitleWrap>
                                        </div>
                                    }
                                    trigger="click"
                                    placement="bottomRight"
                                    open={visible}
                                    onOpenChange={handleVisibleChange}
                                >
                                    <Avatar icon={currentUser.profilePic}>
                                        {getInitials(currentUser.firstName, currentUser.lastName)}
                                    </Avatar>
                                </Popover>
                            </ProfileContainer>
                        </HeaderContainer>
                    </Container>
                </HeaderWrap>
            )}
        </>
    );
};

export default Header;
